<template>
  <div
    ref="elem"
    :id="id"
    :config-properties="JSON.stringify(internal_config)"
    :data-hide-desktop="!internal_config.showDesktop"
    :data-hide-mobile="!internal_config.showMobile"
    :style="style()"
    :key="keyChange"
    element="LottieFileComponent"
    class="sitebuilder-element-container"
    @click="focusElement($event)"
    @contextmenu.prevent="handler($event)">
    <vue-draggable-resizable
      ref="draggableResizable"
      :draggable="false"
      :enable-native-drag="true" :h="parseInt(internal_config.height)"
      :w="parseInt(internal_config.width)" @resizing="onResize">
      <sync-drag :target="this"/>

      <options-element-bar
        ref="optionsBar"
        :elem="this"
        name="ct-component-LottieFileComponent"/>
      <div
        class="sitebuilder-element-lottie-file-content"
        :class="{'sitebuilder-element-lottie-file-content-with-controls' : internal_config.controls}"
        :style="{
          background: internal_config.backgroundColor
      }">
        <lottie-vue-player
          :key="`lottie-player-${keyPlayer}`"
          :src="internal_config.code ? `${getUrl()}/api/get-lottie-files/${internal_config.code}.json` : internal_config.url"
          :player-controls="internal_config.controls"
          :loop="internal_config.loop"
          :speed="internal_config.speed"
          :autoplay="internal_config.autoplay"
          :background-color="internal_config.backgroundColor"
          :style="styleLottieContent()"/>
      </div>
    </vue-draggable-resizable>
  </div>
</template>
<script>

import Model from './Model';
import OptionsElementBar from '../OptionsElementBar';
import { merge } from "lodash";
import {getUrl} from "../../../../js/services/http";

export default {
  name: 'LottieFileComponent',
  components: {
    OptionsElementBar
  },
  props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
  data() {
    return {
      ...Model.data(),
      keyPlayer: 1,
    };
  },
  computed: {},
  created() {
    this.build(this.$props.config);
  },
  mounted() {
    var vm = this;
    this.$root.$on('setLottieFileObj', (idElement) => {
      if(+this.id === +idElement) {
        vm.keyPlayer += 1;
      }
    });

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
    }
  },
  methods: {
    getUrl,
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    minHeight() {
      return this.internal_config.minHeight;
    },
    animation() {
      return false;
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {},
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    style() {
      const styleObj = {
        width: this.internal_config.width,
        'max-width': this.internal_config.maxWidth,
        height: this.internal_config.height,
        'min-height': this.internal_config.minHeight,
        left: this.internal_config.left,
        'z-index': this.internal_config.zIndex,
        margin: '0 auto',
        'padding-top': this.internal_config.paddingTop,
        'padding-left': this.internal_config.paddingLeft,
        'padding-right': this.internal_config.paddingRight,
        'padding-bottom': this.internal_config.paddingBottom,
        top: this.internal_config.top
      };

      if (this.device === 'mobile')
        return merge(styleObj, {height: this.internal_config.minHeight});

      return styleObj;
    },

    styleLottieContent() {

      if (this.device === 'mobile')
        return { width: '100%', height : this.minHeight()};


      return { width: '100%', height: this.internal_config.height,};
    },

    initBuild(config) {
      this.internal_config = merge(this.internal_config, config);
      this.keyPlayer += 1;
    },
    build(config) {
      let vm = this;

      this.internal_config = config;
      this.$forceUpdate();
      this.keyPlayer += 1;

      vm.$eventHub.setValueElementConfig(vm.id, vm.internal_config);
    },
  },
};

</script>

<style lang="scss">
.sitebuilder-element-lottie-file-content {
  &.sitebuilder-element-lottie-file-content-with-controls {
    position: relative;

    #lottie-controls {
      position: absolute;
    }
  }

  .vue-lottie-player {
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/LottieFile/LottieFile.vue